<template>
  <div class="home">
    <promo-advertisement
        v-if="enablePromo"
        :banner="promoImage()"
        :banner-mobile="promoImageMobile()"
        background-color="#081f37"
      background-gradient="linear-gradient(to bottom left, #081f37, #081f37)"
        link="/login"
    />
    <hero-panel />
    <!--domain-promo/-->
    <marketing-block v-for="panel in panels"
      v-bind="panel"
      :key="panel.name"
      view="home" />
    <div class="service-garden-wrapper dark">
      <h2>{{$t('home.SERVICE_GARDEN_HEADING')}}</h2>
      <div class="service-garden">
        <service-garden-item v-for="item in serviceGarden"
          v-bind="item"
          :key="item.name"
          view="home" />
      </div>
    </div>
    <div class="final-cta">
      <h2>{{$t(`home.FINAL_CTA_HEADING`)}}</h2>
      <p>{{$t(`home.FINAL_CTA_BODY`)}}</p>
      <brave-link to="/register">
        <md-button class="md-raised md-primary">{{$t(`home.FINAL_CTA_ACTION`)}}</md-button>
      </brave-link>
    </div>

  </div>
</template>
<script>
import HeroPanel from 'components/home/hero-panel'
import MarketingBlock from 'components/marketing-block'
import PromoAdvertisement from 'components/promo-advertisement'
import DomainPromo from 'components/domain-promo'
import style from 'styles/home.scss'
import {PANELS, SERVICE_GARDENS} from 'app-constants'
import ServiceGardenItem from 'components/service-garden-item'
import axios from 'axios'

export default {
  name: 'home',
  components: {
    'hero-panel': HeroPanel,
    'marketing-block': MarketingBlock,
    'promo-advertisement': PromoAdvertisement,
    'domain-promo': DomainPromo,
    'service-garden-item': ServiceGardenItem
  },
  data () {
    return {
      enablePromo: false,
      panels: PANELS.HOME,
      serviceGarden: SERVICE_GARDENS.HOME,
      loading: true,
      onsale: [],
    }
  },
  methods: {
    onSubmit: function () {
      window.location.href = '/domains/search/results/' + $('.domain-search').val();

    },
    promoImage(){
      // random between 1 and 5
      const random_banner_num = 1;
      return require(`assets/img/shared/promos/2025/blackfridaysale/1138x90/${random_banner_num}.png`)
    },
    promoImageMobile(){
      // random between 1 and 5
      const random_banner_num = 1;
      return require(`assets/img/shared/promos/2025/blackfridaysale/345x215/${random_banner_num}.png`)
    },
    isMobile() {
      return window.innerWidth < 768;
    }
  },
  created() {
    // console.log('isMobile:',this.isMobile());
  },
  async mounted() {
    // if(window.sessionStorage.getItem('bn_domains_sales')!==null) {
    //   this.onsale = JSON.parse(window.sessionStorage.getItem('bn_domains_sales'))
    //   this.loading = false
    // } else {
    //   let res = await axios.get('https://api-v2.bravenet.com/domains/onsale')
    //   window.sessionStorage.setItem('bn_domains_sales',JSON.stringify(res.data))
    //   this.onsale = res.data
    //   this.loading = false
    // }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
.md-progress-spinner {
.md-progress-spinner-circle {
    stroke: #fff!important;
    color: #fff!important;
}
}
</style>




// WEBPACK FOOTER //
// apps/www.bravenet.com/src/views/home.vue